export function TrustLimits() {
  return (
    <section id="trust" className="section">
      <div className="section-inner">
        <p className="section-label">Trust &amp; limits</p>
        <h2>Free and private — with honest limits</h2>
        <div className="prose">
          <p>
            PairBolt stays free because we never host your files. Transfers are
            direct and private by design. That also means we refuse cloud relays
            when a peer path cannot be found.
          </p>
        </div>

        <table className="limit-table">
          <thead>
            <tr>
              <th>Topic</th>
              <th>Behavior</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Price</td>
              <td>Free — no accounts, no per-GB fees, no cloud storage bill</td>
            </tr>
            <tr>
              <td>File contents</td>
              <td>Never stored or relayed by pairbolt.com — direct browser→receiver only</td>
            </tr>
            <tr>
              <td>Large files</td>
              <td>Built for big folders and multi‑TiB totals on a working peer path</td>
            </tr>
            <tr>
              <td>Signaling metadata</td>
              <td>
                Session IDs, ICE candidates (WebRTC fallback), and short-lived
                DNS/ACME state for <code>direct.pairbolt.com</code> — never file
                contents
              </td>
            </tr>
            <tr>
              <td>Pairing codes</td>
              <td>8 chars, short TTL, single-use; rate-limited per IP</td>
            </tr>
            <tr>
              <td>Strict NAT / firewalls</td>
              <td>May force WebRTC fallback if TCP 47443 is unreachable — no TURN/cloud relay</td>
            </tr>
            <tr>
              <td>Browser refresh mid-transfer</td>
              <td>File handles lost; reselect files to resume</td>
            </tr>
            <tr>
              <td>Approval</td>
              <td>Receiver must explicitly approve every transfer</td>
            </tr>
          </tbody>
        </table>

        <div className="prose" style={{ marginTop: "2rem" }}>
          <p>
            The sender page loads no third-party scripts. For air-gapped or
            high-assurance setups, self-host the rendezvous service and STUN
            next to your receiver.
          </p>
        </div>
      </div>
    </section>
  );
}
